const hrHomePath = (user: any) => {
  const group = user?.group?.name;
  if (['Staff', 'Teachers'].includes(group)) {
    return `/users/${user?.id}/profile`;
  }
  if (['Director', 'UpperManagement', 'EducationDirectorAdminAssistant', 'HRUser', 'FinanceUser'].includes(group)) {
    return '/directory';
  }
  return undefined;
};

export default hrHomePath;
